import { Line } from '@components';
import { useScreenSize } from '@hooks';
import { Flex, theme, Typography } from '@styles';
import { string } from 'prop-types';
import React from 'react';

const StatementCard = ({ definition, statement }) => {
  const { isTabletSM } = useScreenSize();

  if (isTabletSM) {
    return (
      <Flex
        backgroundColor={theme.colors.hunterGreen[90]}
        borderColor={theme.colors.whiteLine[100]}
        borderStyle="solid"
        borderWidth={1}
        flexDirection="column"
        gap={24}
        p={24}
      >
        <Typography
          color={theme.colors.white[100]}
          variant="MS-semibold-s18-lh27"
        >
          {statement}
        </Typography>
        <Line flex={1} lineColor={theme.colors.whiteLine[100]} />
        <Flex>
          <Typography
            color={theme.colors.white[100]}
            variant="MS-semiregular-s16-lh21"
          >
            {definition}
          </Typography>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex
      backgroundColor={theme.colors.hunterGreen[90]}
      borderColor={theme.colors.whiteLine[100]}
      borderStyle="solid"
      borderWidth={1}
      p={24}
    >
      <Typography
        color={theme.colors.white[100]}
        variant="MS-semibold-s18-lh27"
        width="28%"
      >
        {statement}
      </Typography>
      <Flex
        borderLeftColor={theme.colors.whiteLine[100]}
        borderLeftStyle="solid"
        borderLeftWidth={2}
        ml={20}
        pl={20}
        width="72%"
      >
        <Typography
          color={theme.colors.white[100]}
          variant="MS-semiregular-s16-lh21"
        >
          {definition}
        </Typography>
      </Flex>
    </Flex>
  );
};

StatementCard.propTypes = {
  definition: string.isRequired,
  statement: string.isRequired,
};

export default StatementCard;
